/*
Page: /challenge
This is a one checking if the customer is not a robot when:
- a password change is requested or
- an account is created (account/register).
This page is a Shopify embedded page that isn't hosted on the store.
That's why we cannot modify it easily.
To do so about the content like adding title, we need to use js
*/

function initChallengePageCustomization() {
  // Get the URL of the previous page
  const previousPageUrl = document.referrer;
  let challengePageTitle = '';

  if (     previousPageUrl.includes("register")){challengePageTitle = "Create an account";}
  else if (previousPageUrl.includes("account-information")){challengePageTitle = "Change my password";} 

  if (challengePageTitle != '')
  {
    const ShopifyChallengeContainer = document.querySelector(".shopify-challenge__container");
    if (ShopifyChallengeContainer) {
      ShopifyChallengeContainer.innerHTML = "<div class=\"user-page-wrapper__title\">" + challengePageTitle + "</div>" + ShopifyChallengeContainer.innerHTML;
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initChallengePageCustomization();
})